import { Button as AntButton } from 'antd';

import './index.scss';

export const Button = ({ className = '', children, ...rest }) => (
    <div className={`spa__button ${className}`}>
        <AntButton {...rest}>{children}</AntButton>
    </div>
);
